import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import LevelBadge from "@/components/LevelBadge";
import { Search } from "lucide-react";

export default function Courses() {
  const [courses, setCourses] = useState([]);
  const [levels, setLevels] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/courses").then(({ data }) => setCourses(data)).catch(() => {});
    api.get("/levels").then(({ data }) => setLevels(data)).catch(() => {});
  }, []);

  const filtered = courses.filter((c) => c.title.toLowerCase().includes(q.toLowerCase()) || (c.description || "").toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="p-5 sm:p-8 max-w-6xl mx-auto">
      <div className="flex items-center justify-between flex-wrap gap-4 mb-8">
        <div><h1 className="font-heading text-3xl text-chessup-text">Cursos</h1><p className="text-chessup-subtext text-sm mt-1">Do Peão ao Rei — escolha por onde começar.</p></div>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-chessup-subtext" />
          <input data-testid="courses-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar cursos..." className="rounded-full bg-chessup-deep border border-chessup-border pl-9 pr-4 py-2.5 text-sm text-chessup-text focus:border-chessup-turq focus:outline-none w-64" />
        </div>
      </div>

      {levels.map((lv) => {
        const list = filtered.filter((c) => c.level_key === lv.key);
        if (!list.length) return null;
        return (
          <div key={lv.key} className="mb-10">
            <div className="flex items-center gap-3 mb-4">
              <LevelBadge levelKey={lv.key} state="disponivel" size={44} />
              <div><h2 className="font-heading text-xl text-chessup-text">Nível {lv.name}</h2><p className="text-xs text-chessup-subtext">{lv.label}</p></div>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {list.map((c) => (
                <Link key={c.id} to={`/cursos/${c.id}`} data-testid={`course-card-${c.id}`} className="group rounded-xl border border-chessup-border bg-chessup-card overflow-hidden hover:border-chessup-turq/50 transition-all">
                  <div className="relative aspect-video overflow-hidden">
                    <img src={c.cover} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    {c.is_new && <span className="absolute top-2 left-2 rounded-full bg-chessup-gold/90 px-2.5 py-0.5 text-xs font-semibold text-chessup-deep">NOVO</span>}
                  </div>
                  <div className="p-5">
                    <span className="text-xs text-chessup-turq font-mono uppercase">{c.difficulty}</span>
                    <h3 className="font-heading text-lg text-chessup-text mt-1">{c.title}</h3>
                    <p className="mt-2 text-sm text-chessup-subtext line-clamp-2">{c.description}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
